import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import { CircularProgress } from "@mui/material";
import AppContext from "../../pages/app/context";
import materialProduto from "../../enums/materialProduto";
import ActionTable from "../../components/table/ActionTable";
import { mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const { notification } = useContext(AppContext);
  const [categorias, setCategorias] = useState([]);
  const [filtros, setFiltros] = useState(mergeParams({ produto: 0 }, location));
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    listarCategorias();
  }, []);

  const listarCategorias = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    setCarregando(true);
    api
      .get("materiais/categorias/listar", filtrosEnviar)
      .then((categorias) => {
        setCategorias(categorias);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível listar as categorias");
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Produto Perto",
    form: {
      produto: {
        label: "Produto",
        type: "select",
        emptyItem: true,
        emptyItemText: "(Todos)",
        options: [
          {
            value: 1,
            desc: "Bilíngue",
          },
          {
            value: 2,
            desc: "Uni Dune Tê",
          },
        ],
        value: filtros.produto,
      },
    },

    submit: {
      label: "Buscar",
      action: listarCategorias,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Categorias",
    newItemAction: () => history.push("/app/material-categoria/0"),
    onLineClick: (categoria) =>
      history.push(`/app/material-categoria/${categoria.id}`),
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
      {
        name: "produto",
        label: "Produto",
        domain: materialProduto,
      },
    ],
    array: categorias,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
